import { render, staticRenderFns } from "./SchemaEdit.vue?vue&type=template&id=5acc75be&scoped=true&"
import script from "./SchemaEdit.vue?vue&type=script&lang=js&"
export * from "./SchemaEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchemaEdit.vue?vue&type=style&index=0&id=5acc75be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acc75be",
  null
  
)

export default component.exports